import Checkbox from 'app/components/checkbox'
import { Tooltip } from 'app/modules/reports/components/tooltip'
import React, { useEffect, useRef, useState } from 'react'
import { ListChildComponentProps } from 'react-window'
import { YaraRuleExtendedData } from '../../yara-report/types'

interface YaraRuleRowData {
  filteredRules: YaraRuleExtendedData[]
  selectedRules: string[]
  previewRule: YaraRuleExtendedData | null
  handleSelectRule: (rule: string) => void
  handlePreview: (rule: YaraRuleExtendedData) => void
}

const YaraRuleRow = ({ index, style, data }: ListChildComponentProps<YaraRuleRowData>) => {
  const { filteredRules, selectedRules, previewRule, handleSelectRule, handlePreview } = data
  const rule = filteredRules[index]
  const ruleNameRef = useRef<HTMLSpanElement>(null)
  const [isTruncated, setIsTruncated] = useState(false)

  useEffect(() => {
    const ruleNameElement = ruleNameRef.current
    if (!ruleNameElement) {
      return
    }

    const checkTruncation = () => setIsTruncated(ruleNameElement.scrollWidth > ruleNameElement.clientWidth)

    checkTruncation()
    window.addEventListener('resize', checkTruncation)
    return () => window.removeEventListener('resize', checkTruncation)
  }, [rule.name])

  return (
    <div style={style} className={`yara-rules-list-element${rule.name === previewRule?.name ? ' selected' : ''}`}>
      <div className="yara-rule-cb">
        <Checkbox onChange={() => handleSelectRule(rule.name)} checked={selectedRules.includes(rule.name)} />
      </div>
      <span className="yara-rule-name" onClick={() => handlePreview(rule)}>
        <Tooltip content={isTruncated ? rule.name : undefined}>
          <span ref={ruleNameRef} className="d-block w-100 text-truncate">
            {rule.name}
          </span>
        </Tooltip>
      </span>
    </div>
  )
}

export default YaraRuleRow
